import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert


const referRewardCoinInput = byId('referRewardCoinInput');
const referRewardAmountInput = byId('referRewardAmountInput');
const registerRewardCoinInput = byId('registerRewardCoinInput');
const registerRewardAmountInput = byId('registerRewardAmountInput');
const minimumMatchFeesInput = byId('minimumMatchFeesInput');
const referAndEarnSettingsSubmitBtn = byId('referAndEarnSettingsSubmitBtn');
const referAndEarnSettingsEditBtn = byId('referAndEarnSettingsEditBtn');



const referAndEarnSettings = {
    get: async () => {

        try {
            const response = await callTheApServerGet(`/basic/getReferAndEarnConfig`);
            axiosResponseHandler(response);
            const res = response.data;

            if (res.status === 'success') {
                console.log(res);

                const { referRewardCoin, referRewardAmount, registerRewardCoin, registerRewardAmount, minimumMatchFees } = res.referAndEarnConfigData;

                referRewardCoinInput.value = referRewardCoin;
                referRewardAmountInput.value = referRewardAmount;
                registerRewardCoinInput.value = registerRewardCoin;
                registerRewardAmountInput.value = registerRewardAmount;
                minimumMatchFeesInput.value = minimumMatchFees;

                // setTimeout(() => {
                //     location.reload();
                // }, 3000);



            }
        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }
    },
    edit: () => {
        referRewardCoinInput.disabled = referRewardAmountInput.disabled = registerRewardCoinInput.disabled = registerRewardAmountInput.disabled = minimumMatchFeesInput.disabled = false;
        addDNoneClass(referAndEarnSettingsSubmitBtn, false);
        addDNoneClass(referAndEarnSettingsEditBtn, true);
    },
    submit: async () => {

        const data = {
            referRewardCoin: referRewardCoinInput.value,
            referRewardAmount: referRewardAmountInput.value,
            registerRewardCoin: registerRewardCoinInput.value,
            registerRewardAmount: registerRewardAmountInput.value,
            minimumMatchFees: minimumMatchFeesInput.value,

        };
        callTheApServerPost(`/basic/updateReferAndEarnConfig`, { data: data }).then((response) => {
            axiosResponseHandler(response);
            const res = response.data;






            if (res.status === 'success') {
                console.log(res);


                Swal.fire({
                    title: 'referAndEarnSettings Updated',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);



            }
        }).catch((error) => {
            axiosErrorHandler(error);
            console.log(error);
        });

    }
};

window.referAndEarnSettings = referAndEarnSettings;
referAndEarnSettings.get();







